<template>
    <div class="app-wrapper bg-white h-100">
        <div class="app-main">
            <div class="app-content p-0">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1 w-100 d-flex align-items-center">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-6 pl-0 d-none d-sm-flex align-items-center hide-image">
                                    <div class="wrap" :style="wrapStyle">
                                        <img src="@/assets/img/forgot.jpg" alt="login izidok" :style="wrapImgStyle" />
                                    </div>
                                </div>
                                <div class="col-md-6 p-0 d-flex justify-content-center align-self-center">
                                    <div class="col-sm-10 mt-2" style="margin-left:auto;margin-right:auto;font-size:14px;">
                                        <div class="row">
                                            <img
                                                src="/img/izidok.baaa69b4.png"
                                                alt="izidok"
                                                class="img-fluid w-100 d-block float-left"
                                                style="width: 49% !important;height:100%;"
                                            >
                                        </div>
                                        <label class="mb-5" style="color:#b8b8b8;">
                                            <h5><strong>Set Password Akun Anda</strong></h5>
                                        </label>
                                        <b-form @submit.prevent="submitForm">
                                            <template v-if="formBasicData && formBasicData.length">
                                                <b-form-group
                                                    v-for="form in formBasicData"
                                                    :key="form.tmpId"
                                                    :invalid-feedback="
                                                        renderInvalidFeedback({
                                                        validationDesc: form['validation-desc']
                                                        })
                                                    "
                                                    :state="renderError({ error: form.error })"
                                                    style="margin-top:-10px;"
                                                >
                                                    <template v-if="form.isType === 'password' || form.isType == 'password'">
                                                        <label class="text-capitalize font-weight-bold" style="color:#b8b8b8;">{{ form.rawLabel }}</label>
                                                        <label style="color:red"> *</label>
                                                        <b-input-group>
                                                            <b-input-group-text
                                                                slot="append"
                                                                class="border-left-0"
                                                                v-if="form.name == 'password'"
                                                                @click="switchVisibilityPassword"
                                                            >
                                                                <font-awesome-icon v-if="passwordVisible == false" icon="eye" />
                                                                <font-awesome-icon v-else icon="eye-slash" />
                                                            </b-input-group-text>
                                                            <b-input-group-text
                                                                slot="append"
                                                                class="border-left-0"
                                                                v-if="form.name == 'password_confirmation'"
                                                                @click="switchVisibilityPasswordConfirmation"
                                                            >
                                                                <font-awesome-icon v-if="passwordVisible1 == false" icon="eye" />
                                                                <font-awesome-icon v-else icon="eye-slash" />
                                                            </b-input-group-text>
                                                            <b-form-input
                                                                :type="form.type || 'text'"
                                                                class="border-right-0"
                                                                @input="
                                                                    setValue({
                                                                        rawLabel: form.rawLabel,
                                                                        label: form.label,
                                                                        $event,
                                                                        tmpId: form.tmpId
                                                                    })
                                                                "
                                                                :state="renderError({ error: form.error })"
                                                                :maxlength="form.maxlength"
                                                                :placeholder="form.placeholder"
                                                            />
                                                        </b-input-group>
                                                    </template>
                                                </b-form-group>
                                            </template>
                                            <button
                                                type="submit"
                                                class="btn btn-md btn-block text-capitalize"
                                                style="background-color :#3F7EA7; color:white; border-radius : 10px;"
                                            >
                                                AKTIVASI
                                            </button>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
    required,
    minLength,
    maxLength,
    sameAs
} from "vuelidate/lib/validators";

library.add(faEye, faEyeSlash);

export default {
    data: () => ({
        formBasicData: null,
        formData: null,
        validateEmail: false,
        validateUsername: false,
        selected: null,
        passwordVisible: false,
        passwordVisible1: false,
        windowHeight: 0
    }),
    validations() {
        return {
            formData: {
                password: {
                    required,
                    maxLength: maxLength(15),
                    verifyPassword(val) {
                        if (val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                },
                konfirmasi_password: {
                    required,
                    sameAsPassword: sameAs("password"),
                    minLength: minLength(6),
                    maxLength: maxLength(15)
                }
            }
        };
    },
    created() {
                this.formBasicData = this.setFormBasicData();
    },
    mounted() {
        this.setFormData();
        this.windowHeight = window.innerHeight;
        this.$nextTick(() => {
            window.addEventListener("resize", e => {
                this.windowHeight = window.innerHeight;
            });
        });
    },
    computed: {
        wrapStyle() {
            return {
                height: this.windowHeight + "px"
            };
        },
        wrapImgStyle() {
            return {
                "max-height": this.windowHeight + "px"
            };
        }
    },
    methods: {
        switchVisibilityPassword() {
            this.formBasicData[0].type == "password" ?
                (this.formBasicData[0].type = "text") :
                (this.formBasicData[0].type = "password");
            if (this.formBasicData[0].type == "text") {
                this.passwordVisible = true;
            } else if (this.formBasicData[0].type == "password") {
                this.passwordVisible = false;
            }
        },
        switchVisibilityPasswordConfirmation() {
            this.formBasicData[1].type == "password" ?
                (this.formBasicData[1].type = "text") :
                (this.formBasicData[1].type = "password");
            if (this.formBasicData[1].type == "text") {
                this.passwordVisible1 = true;
            } else if (this.formBasicData[1].type == "password") {
                this.passwordVisible1 = false;
            }
        },
        whitelistValidation({ opts = "normalized" } = {}) {
            const tmp = [""];
            return opts === "raw" ? tmp : tmp.map(item => item.split(" ").join("_"));
        },
        async activation() {
            try {
                const { formData, formBasicData } = this;

                const tmpPostData = formBasicData.reduce((obj, item) => {
                    const { label, name } = item;
                    obj[name] = formData[label];
                    return obj;
                }, {});

                const res = await this.$axios.post(
                    `activate_password/${this.$router.currentRoute.params.token}`,
                    tmpPostData
                );
                const { status } = res.data;

                if (status) {
                    this.$router.push({
                         name: "verification-result",
                            params: {
                                state: "success"
                            }
                    });
                } else {
                    this.$swal({
                        text: "Set password akun gagal",
                        type: "warning",
                        confirmButtonText: startCase("OK")
                    });
                }
            } catch (err) {
                // console.log(err);
            }
        },
        submitForm() {
            const tmp = this.formBasicData.filter(
                item => !this.whitelistValidation().includes(item.label)
            );
            if (tmp.every(item => item.error !== null && !item.error)) {
                this.activation();
            } else {
                tmp.map(item => {
                    this.triggerValidation({
                        label: item.label,
                        $v: this.$v,
                        $vm: this
                    });
                });
            }
        },
        setFormData() {
            this.formData = this.setFormBasicData({
                noFilter: false
            }).reduce((arr, val) => {
                arr[val.label.split(" ").join("_")] = "";
                return arr;
            }, {});
        },
        setFormBasicData({ noFilter = true, showHidden = false } = {}) {
            const tmp = [
                {
                    label: "password",
                    placeholder: "Masukkan password Anda",
                    type: "password",
                    isType: "password",
                    name: "password",
                    maxlength: 15,
                    rawLabel: "password"
                },
                {
                    label: "konfirmasi password",
                    placeholder: "Masukkan password Anda sekali lagi",
                    type: "password",
                    rawLabel: "konfirmasi password",
                    isType: "password",
                    name: "password_confirmation",
                    maxlength: 15
                }
            ].map((item, index) => ({
                ...item,
                label: item.label.split(" ").join("_"),
                tmpId: index,
                error: null,
                placeholder: item.placeholder,
                rawLabel: item.rawLabel
            }));

            return showHidden ? tmp : tmp.filter(item => !item.hide);
        },
        setValue({ label, rawLabel, $event = null } = {}) {
            const value = $event;
            this.formData[label] = value && value.trim();
            if (!this.whitelistValidation().includes(label)) {
                const confirms = ["password", "konfirmasi_password"];
                if (confirms.includes(label)) {
                    confirms.forEach(item => {
                        this.triggerValidation({
                            label: item,
                            $v: this.$v,
                            $vm: this,
                            rawLabel: item.split("_").join(" ")
                        });
                    });
                } else {
                    this.triggerValidation({
                        label,
                        $v: this.$v,
                        $vm: this,
                        rawLabel
                    });
                }
            }
        }
    }
};
</script>
<style lang="scss">
    .dot-icon {
        width: 30px;
        height: 28px;
        background-color: white;
        border-radius: 50%;
    }

    .bg-composed-wrapper--bg,
    .bg-composed-wrapper--image {
        opacity: 0.35;
    }

    .slick-dots li.slick-active button {
        width: 20px;
        background: #cac0c0;
    }

    .slick-dots {
        margin-bottom: 150px;
    }

    .img-banner-left {
        position: fixed;
    }

    .content-register-right {
        position: absolute;
        right: 0px;
    }

    .wrap {
        width: 100%;
        height: 100%;
        position: relative;
        display: inline-block;
        overflow: hidden;
        margin: 0;
    }

    .wrap img {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        min-height: 100%;
        min-width: 100%;
        transform: translate(-50%, -50%);
    }

    @media only screen and (max-width: 600px) {
        .img-banner-left {
            position: relative;
            display: none;
        }

        .content-register-right {
            position: relative;
        }
    }
</style>